export const CONTACT_EMAIL = "contact@ecircuitmania.com";
export const DISCORD_LINK = "https://discord.gg/rcVkdw2CMD";
export const PATREON_LINK = "https://www.patreon.com/eCircuitMania";
export const X_LINK = "https://x.com/eCircuitMania";
